import { css } from '@/styled-system/css';

export const carouselSkipLinkStyles = css.raw({
  // visually hide the skip link
  srOnly: true,

  _focusVisible: {
    // reset the visually hidden styles
    display: 'block',
    position: 'absolute',
    overflow: 'visible',
    clip: 'auto',
    clipPath: 'none',
    margin: 0,

    // custom styles
    backgroundColor: 'bg.neutral',
    height: 'action.md',
    lineHeight: '{sizes.action.md}',
    textAlign: 'center',
    textStyle: 'body',
    width: '100%',
    zIndex: 10,
  },
});
